import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencyMainHome.css';
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Popper from '@mui/material/Popper';

const AgencyMainHome = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [agentSports, setAgentSports] = useState([]);

    const [searchValue, setSearchValue] = useState('');
    const [options, setOptions] = useState([]);

    useEffect(() => {
    // Implement debouncing here if needed
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        const response = await fetch(app_url+'user/getagentathletelist?query='+searchValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);
  
  const renderOption = (props, option) => (
  <li {...props}>
    <Link href={option.link} color="inherit" underline="hover">
      {option.label}
    </Link>
  </li> 
);

const getOptionLabel = (option) => option.label;

const onChange = (event, newValue) => {
  if (newValue && newValue.link) {
    window.location.href = newValue.link;
  }
};

    function CustomPopper(props) {
        const { anchorEl, style, ...other } = props;

        return (
            <Popper
                anchorEl={anchorEl}
                placement="bottom"
                modifiers={[
                    {
                    name: "computeStyles",
                    options: { adaptive: false }
                    },
                    {
                    name: "sameWidth",
                    enabled: true,
                    phase: "beforeWrite",
                    requires: ["computeStyles"],
                    fn: ({ state }) => {
                        state.styles.popper.width = `${anchorEl?.offsetWidth}px`;  // match input width
                    }
                    }
                ]}
                style={{
                    ...style,
                    zIndex: "0"
                }}
                {...other}
            />
        );
    }

    // function CustomPopper(props) {
    //   const { anchorEl, style, ...other } = props;

    //   return (
    //     <Popper
    //       anchorEl={anchorEl}
    //       placement="bottom"
    //       modifiers={[
    //         {
    //           name: "computeStyles",
    //           options: { adaptive: false }
    //         }
    //       ]}
    //       style={{
    //         ...style,
    //         left: "50%",
    //         transform: "translateX(-50%)"
    //       }}
    //       {...other}
    //     />
    //   );
    // }

    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'Baseball',
                image: '/basic/web/images/agent/new-linkbox-baseball.png',
                url:'/sports/baseball',
            },
            {   
                id: "2", 
                name: 'Basketball',
                image: '/basic/web/images/agent/new-linkbox-basketball.png',
                url:'/sports/basketball',
            },
            {   
                id: "3", 
                name: 'Cricket',
                image: '/basic/web/images/agent/new-linkbox-cricket.png',
                url:'/sports/cricket',
            },
            {   
                id: "4", 
                name: 'Football',
                image: '/basic/web/images/agent/new-linkbox-football.png',
                url:'/sports/football',
            },
            {   
                id: "5", 
                name: 'Hockey',
                image: '/basic/web/images/agent/new-linkbox-hockey.png',
                url:'/sports/hockey',
            },
            {   
                id: "6", 
                name: 'Racing',
                image: '/basic/web/images/agent/new-linkbox-racing.png',
                url:'/sports/racing',
            },
            {   
                id: "7", 
                name: 'Rugby',
                image: '/basic/web/images/agent/new-linkbox-rugby.png',
                url:'/sports/rugby',
            },
            {   
                id: "8", 
                name: 'Soccer',
                image: '/basic/web/images/agent/new-linkbox-soccer.png',
                url:'/sports/soccer',
            },
        ];
        setAgentSports(staticData);
    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
            setIsLoading(false);
        })
    },[]);

    const handleClick = (continent) => {
        navigate('/continents/'+continent+'/agents');
    };

    const handleUSClick = () => {
        navigate('/sports_agents_usmap');
    };

    const handleCanadaClick = () => {
        navigate('/sports_agent_canada_map');
        // window.location.href="/sports_agent_canada_map";
    };

    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="agency-home-main">
                <Helmet><title>SMWW Sports Agency</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="whitebox nomargfr">
                        <div className="data2">Sports Management Worldwide is an international full-service sports agency with an extensive network of Agent Advisors serving athletes throughout the world.<br />
                        <a href="/lookingforagent.php">
                            <img alt="Request Agent" src="/basic/web/images/agent/reqagentbtn.jpg" style={{marginTop:"10px"}} />
                        </a>
                        </div>
                    </div>
                    <div className="player">
                        {/* <a href="https://www.smwwagency.com/athlete/kavontae-turpin" target="_self"> */}
                            <img alt="" src="/basic/web/images/agent/agency_head_new3.png" />
                        {/* </a> */}
                    </div>
                    <div style={{clear: "both"}}></div>
                    <h1>Assisting Professional Athletes On and Off the Field</h1>
                    {agentSports.map((agentSport, index) => (
                        <div className={`linkbox sport-image-${index}`} key={index}>
                            <a href={agentSport.url}><img src={agentSport.image} alt={agentSport.name} /></a>
                        </div>
                    ))}
                    <div style={{clear:"both"}}>&nbsp;</div>
                    <div>
                        <h1>View Agents Near You</h1>
                        <p style={{fontSize:"16px", fontWeight:"bold", textAlign: "center"}}>
                            To view our rapidly expanding network of agents around the world,<br />
                            click below.
                        </p>
                        <div className="mobilemaparea">
                            <h1><a href onClick={(e) => {e.preventDefault(); handleCanadaClick();}}>Agents in Canada</a></h1>
                            <h1><a href onClick={(e) => {e.preventDefault(); handleClick('1');}}>Agents in Mexico and the Central Americas</a></h1>
                            <h1><a href onClick={(e) => {e.preventDefault(); handleUSClick();}}>Agents in US</a></h1>
                            <h1><a href onClick={(e) => {e.preventDefault(); handleClick('2');}}>Agents in South America</a></h1>
                            <h1><a href onClick={(e) => {e.preventDefault(); handleClick('3');}}>Agents in Europe</a></h1>
                            <h1><a href onClick={(e) => {e.preventDefault(); handleClick('4');}}>Agents in Asia &amp; Middle East</a></h1>
                            <h1><a href onClick={(e) => {e.preventDefault(); handleClick('5');}}>Agents in Africa</a></h1>
                            <h1><a href onClick={(e) => {e.preventDefault(); handleClick('6');}}>Agents in South Pacific</a></h1>
                            <br />
                        </div>
                        <div align="center" className="webmaparea">
                            <img border="0" src="/basic/web/images/agencyhome-map.jpg" style={{width:"100%", maxWidth:"800px", height:"auto"}} usemap="#Mapu" />
                            <map id="Mapu" name="Mapu">
                                <area coords="11,32,104,124" onClick={(e) => {e.preventDefault(); handleUSClick();}} shape="rect" /> 
                                <area coords="104,97,256,148" onClick={(e) => {e.preventDefault(); handleUSClick();}} shape="rect" /> 
                                <area coords="105,13,365,98" onClick={(e) => {e.preventDefault(); handleCanadaClick();}} shape="rect" /> 
                                <area coords="105,148,241,188" onClick={(e) => {e.preventDefault(); handleClick('1');}} shape="rect" /> 
                                <area coords="190,187,326,350" onClick={(e) => {e.preventDefault(); handleClick('2');}} shape="rect" /> 
                                <area coords="368,32,541,119" onClick={(e) => {e.preventDefault(); handleClick('3');}} shape="rect" /> 
                                <area coords="544,26,794,239" onClick={(e) => {e.preventDefault(); handleClick('4');}} shape="rect" /> 
                                <area coords="911,330,1051,440" onClick={(e) => {e.preventDefault(); handleClick('6');}} shape="rect" /> 
                                <area coords="655,239,774,334" onClick={(e) => {e.preventDefault(); handleClick('6');}} shape="rect" /> 
                                <area coords="352,128,525,310" onClick={(e) => {e.preventDefault(); handleClick('5');}} shape="rect" /> 
                                <area coords="488,120,544,178" onClick={(e) => {e.preventDefault(); handleClick('4');}} shape="rect" />
                            </map> 
                        </div>
                        <a className="reddbtnn" href="/agents">view a list of all Agents</a>
                    </div>
                    <div className="agent-block">
                        <h2>Agent &amp; Athlete Search</h2>
                        <div className="">
                            <p style={{display: 'flex', alignItems: 'flex-end'}}>
                                <Autocomplete
                                    id="user_search"
                                    disablePortal
                                    options={options}
                                    //  sx={{ width: 300 }}
                                    sx={{ 
                                        width: "100%", 
                                        backgroundColor:"#fff",
                                        // border: "1px solid #ccc",
                                        // maxHeight: "20px", 
                                        display: "inline-block"
                                    }}
                                    PopperComponent={CustomPopper}
                                    renderOption={renderOption}
                                    getOptionLabel={getOptionLabel}
                                    onChange={onChange}
                                    renderInput={(params) => <TextField {...params} onChange={(event) => setSearchValue(event.target.value)}/>}
                                />
                            </p>

                        </div>
                    </div>
                </div>
                <div className="right"></div>
            </div>
        )}
        </>
    );
};
export default AgencyMainHome;